import { Menu } from '@mui/icons-material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import LinearProgress from '@mui/material/LinearProgress';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { userLogged } from 'common/selectors/user';
import { AppState, franchiseSelector } from 'common/store/store';
import MinHeightContainer from 'front/MinHeightContainer';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import InsightDrawer from './InsightDrawer';
import { useInsightDrawer } from './useInsightDrawer';

const DrawerMenu = (props: { toggleDrawer?: (open: boolean) => void; }) => {
    const user = useSelector((state: AppState) => userLogged(state));
    const userFranchise = useSelector((state: AppState) => franchiseSelector.selectById(state, user?.franchiseId ?? 0));
    const navigate = useNavigate();
    return <Box sx={{ width: 250 }} role="presentation" onClick={() => {
        if (props.toggleDrawer) {
            props.toggleDrawer(false);
        }
    }}>
        <List>
            <ListItem key={'soumissions'} disablePadding>
                <ListItemButton onClick={() => { navigate('/admin/soumissions'); }}>
                    <ListItemText primary={'Soumissions'} />
                </ListItemButton>
            </ListItem>
            <ListItem key={'projets'} disablePadding>
                <ListItemButton onClick={() => { navigate('/admin/projets'); }}>
                    <ListItemText primary={'Projets'} />
                </ListItemButton>
            </ListItem>
            <ListItem key={'territoires'} disablePadding>
                <ListItemButton onClick={() => { navigate('/admin/territoires'); }}>
                    <ListItemText primary={'Territoire(s)'} />
                </ListItemButton>
            </ListItem>

            {user?.isAdmin === true ? <>
                <ListItem key={'reviews'} disablePadding>
                    <ListItemButton onClick={() => { navigate('/admin/reviews'); }}>
                        <ListItemText primary={'Commentaires google'} />
                    </ListItemButton>
                </ListItem>
                <ListItem key={'franchises'} disablePadding>
                    <ListItemButton onClick={() => { navigate('/admin/franchises'); }}>
                        <ListItemText primary={'Franchise(s)'} />
                    </ListItemButton>
                </ListItem>
                <ListItem key={'campagnes'} disablePadding>
                    <ListItemButton onClick={() => { navigate('/admin/campagnes'); }}>
                        <ListItemText primary={'Campagne(s)'} />
                    </ListItemButton>
                </ListItem>
                <ListItem key={'zones'} disablePadding>
                    <ListItemButton onClick={() => { navigate('/admin/zones'); }}>
                        <ListItemText primary={'Zones'} />
                    </ListItemButton>
                </ListItem>
                <ListItem key={'access'} disablePadding>
                    <ListItemButton onClick={() => { navigate('/admin/administrateurs'); }}>
                        <ListItemText primary={'Administrateurs'} />
                    </ListItemButton>
                </ListItem>
                <ListItem key={'parametres'} disablePadding>
                    <ListItemButton onClick={() => { navigate('/admin/parametres'); }}>
                        <ListItemText primary={'Paramètres'} />
                    </ListItemButton>
                </ListItem>
            </> : <>
                {userFranchise ? <ListItem key={'franchises'} disablePadding>
                    <ListItemButton onClick={() => { navigate('/admin/franchise/' + userFranchise.id); }}>
                        <ListItemText primary={'Ma franchise'} />
                    </ListItemButton>
                </ListItem> : null}
            </>}
        </List>
        <Divider />
        <List>

            <ListItem key={'logout'} disablePadding>
                <ListItemButton onClick={() => { document.location.href = '/auth/logout'; }}>
                    <ListItemText primary={'Se déconnecter'} />
                </ListItemButton>
            </ListItem>
            <ListItem key={'retoursite'} disablePadding>
                <ListItemButton onClick={() => { document.location.href = '/'; }}>
                    <ListItemText primary={'Retour au site'} />
                </ListItemButton>
            </ListItem>

        </List>
    </Box >;
};

export default (props: { children?: React.ReactNode; }) => {
    const [open, setOpen] = React.useState(false);
    const { isOpen: insightOpen, drawerWidth } = useInsightDrawer();

    const loading = useSelector((state: AppState) => state.device.loading);
    const loadedRoutes = useSelector((state: AppState) => state.device.loadedRoutes);

    React.useEffect(() => { console.log('loadedRoutes', loadedRoutes); }, [loadedRoutes]);

    const toggleDrawer = (newOpen: boolean) => {
        setOpen(newOpen);
    };
    const getContent = () => {
        return <><MinHeightContainer sx={{ overflowX: 'scroll' }}>
            {loading ? <Box sx={{ position: 'fixed', top: 0, left: 0, width: '100%' }}>
                <LinearProgress />
            </Box> : null}
            <Box sx={{ display: { xs: 'block', sm: 'block', md: 'none', lg: 'none', xl: 'none' } }}>
                <Box sx={{ pb: '20px' }}>
                    <AppBar position="static">
                        <Toolbar>
                            <IconButton
                                size="large"
                                edge="start"
                                color="inherit"
                                aria-label="menu"
                                sx={{ mr: 2 }}
                                onClick={() => {
                                    toggleDrawer(true);
                                }}
                            >
                                <Menu />
                            </IconButton>
                            <Box sx={{ height: 40, mr: 1, ml: 1 }} component='img' src="/images/PieuxProTechFondOrange.png" alt="Pieux Protech" />
                            <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 700 }}>
                                Console Admin
                            </Typography>
                            <Button color="inherit">Logout</Button>
                        </Toolbar>
                    </AppBar>
                </Box>
                <Drawer open={open} onClose={() => toggleDrawer(false)}><DrawerMenu toggleDrawer={toggleDrawer} /></Drawer>
            </Box>
            <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block' } }}>
                <Drawer open variant="permanent"><DrawerMenu /></Drawer>
            </Box>
            <Box sx={{ ml: { xs: 0, sm: 0, md: '250px' }, mr: insightOpen ? `${drawerWidth}px` : 0, position: 'absolute', width: { xs: '100%', sm: '100%', md: insightOpen ? `calc(100% - ${250 + drawerWidth}px)` : 'calc(100% - 250px)' }, height: '100%', overflow: 'scroll' }}>
                {props.children}
            </Box>
            <InsightDrawer />
        </MinHeightContainer>
        </>;
    };
    return <>{getContent()}</>;


};
